import { DeviceGroupValidationContext } from './device-group-validation-context';
import { DeviceGroupVaultOperation } from './device-group-vault-operation';
export class DeviceGroupVault {
    constructor(entries) {
        this.entries = [];
        this.entries = entries.sort((a, b) => a.entryId - b.entryId);
    }
    get effectiveEntries() {
        const entriesWithoutNoOp = this.entries.filter(entry => entry.operation !== DeviceGroupVaultOperation.NoOp);
        const grouppedEntries = entriesWithoutNoOp
            .reduce((dict, entry) => {
            dict[entry.groupId] = entry;
            return dict;
        }, {});
        const grouppedEntriesValues = Object.values(grouppedEntries);
        return grouppedEntriesValues.filter(e => e.operation !== DeviceGroupVaultOperation.Remove);
    }
    effectiveEntriesAt(at) {
        const entriesWithoutNoOp = this.entries
            .filter(entry => entry.operation !== DeviceGroupVaultOperation.NoOp && entry.addedAt <= at);
        const grouppedEntries = entriesWithoutNoOp
            .reduce((dict, entry) => {
            dict[entry.groupId] = entry;
            return dict;
        }, {});
        const grouppedEntriesValues = Object.values(grouppedEntries);
        return grouppedEntriesValues.filter(e => e.operation !== DeviceGroupVaultOperation.Remove);
    }
    static async Create(entries, keyVault, allowEmpty = false, cachedEntryCount = 0) {
        const vault = new DeviceGroupVault(entries);
        const validationContext = new DeviceGroupValidationContext(entries, keyVault, allowEmpty, cachedEntryCount);
        await validationContext.validateAll();
        return vault;
    }
    getLastEntry() {
        return this.entries.length > 0 ? this.entries[this.entries.length - 1] : null;
    }
}
